import React from "react";
import Person from "../Person";
import { ROLE_LABELS } from "./constants";

export default function WorkspaceAccountCard({ user, ws }) {
  return (
    <div className="card border-0">
      <div className="card-header bg-transparent border-bottom">
        <h5 className="mb-0">Mon compte dans l'espace</h5>
      </div>
      <div className="card-body p-3">
        <div className="d-flex align-items-center gap-3 p-2">
          <Person
            person={{
              image: user?.userImage,
              nom: user?.nom,
              prenom: user?.prenom,
              colors: user?.color,
              userId: user?.userId,
            }}
          />
          <div className="flex-fill">
            <strong>
              {user?.prenom} {user?.nom}
            </strong>
            <br />
            <small className="text-muted">Vous</small>
          </div>
          <span className="badge bg-light text-muted text-capitalize">
            {ROLE_LABELS[ws.role] || ws.role}
          </span>
        </div>
      </div>
    </div>
  );
}
